// All pages
export const generalErrMsg = "משהו לא הסתדר. בבקשה נסה שוב מאוחר יותר";

// Register page
export const allFieldsReqMsg = "כל השדות הינם חובה.";
export const passwordsMustMatchMsg = "הסיסמה ואישור הסיסמה שהוזנו אינם תואמות";
export const passwordReqMsg = "הסיסמה חייבת להיות בעלת 6 תוים לפחות";
export const userEmailExistsMsg = "האימייל כבר קיים במערכת";
export const userExistsInPendingListTitle = 'הדוא"ל שהזנת הינו בטיפולינו';
export const userExistsInPendingListMsg = "ניתן ליצור איתנו קשר במידה ואתה רוצה לזרז את התהליך";

export const userCreatedTitle = "משתמש חדש נוצר בהצלחה";
export const userCreatedMsg = "יש לבדוק את תיבת האימייל שלך על מנת לאשר את המייל";

// Login page
export const incorrectEmailOrPassTitle = "אימייל או סיסמה לא נכונים";
export const incorrectEmailOrPassMsg = "בבקשה נסה שנית";
export const anotherConfEmailSend = "אימייל נוסף לאישור נשלח";
export const tooManyAttemptsMsg = "ניסית לשלוח מייל עם אישור יותר מידי פעמים. ניתן לנסות שוב בעוד כמה שעות או להתקשר אלינו";
export const subscriptionOutOfDateTitle = "המנוי אינו בתוקף";
export const needsConfMsg = "לקוח יקר עליך לאשר את האימייל שלך על מנת להמשיך";
export const resendEmailConfMsg = "במידה ולא קבלת אימייל מאיתנו ניתן ללחוץ כאן לשליחה נוספת";
export const subscriptionOutOfDateMsg = "בבקשה צור איתנו קשר :)";

// Forgot password page
export const emailDontMatchMsg = "Emails do not match";
export const noUserEmailMsg = "יוזר לא קיים";
export const cantResetPassTitle = "לא ניתן לשחזר סיסמה כרגע. במידה ובעיה זו ממשיכה בבקשה צור איתנו קשר";
export const userEmailNotConfirmedMsg = "המייל שהוכנס לא אושר";
export const badEmailFormat = "המייל שהוכנס לא תקין";

// Reset password
export const successTitle = "Success";
export const successMsg = "Please check your email";

// set new pass page
export const tokenProvidedNotValid = "הבקשה אינה בתוקף";
export const passResetSuccess = "הסיסמה שונתה בהצלחה";

// edit client info
export const editSuccessMsg = "Your information has been updated";
// conf page
export const userConfirmedTitle = "Your email has been confirmed!";
export const userConfirmedMsg = "You may login now";

// Deals page
export const addNewDealMsg = "להוסיף עסקה חדשה?";
export const addDealSuccessMsg = "עסקה חדשה נוספה בהצלחה";
export const deleteDealMsg = "למחוק עסקה?";
export const deleteDealSuccessMsg = "עסקה נמחקה בהצלחה";
export const updateDealMsg = "לעדכן עסקה?";
export const updateDealSuccessMsg = "עסקה עודכנה בהצלחה";
// btax

export const newDealDetectedTitle = "האם להעביר נתוני עסקה קיימת ל-Bquick?";
export const newDealDetectedMsg = "(עסקת ביטקס מס - '%btaxDealId%')";
export const existingDealDetected = "מצאנו שעסקה %btaxDealId% כבר קיימת. רוצה להכנס אליה?";

// Comments
export const minimum4Letters = "הערה חייבת להיות לפחות 4 תוים";
export const addNewComment = "להוסיף תגובה חדשה?";

// choose-docs
export const sendClientFillingEmailTitle = "שליחה ללקוח %dealName%";
export const sendClientFillingEmailMsg = "האם אתה רוצה לתת ללקוח למלא את הנתונים במקומך? במידה וכן, אכנס מייל של הלקוח";
export const emailSentToClientToFillData = "אימייל עם בקשה למילוי הנתונים נשלח ללקוח";

export const clientEditsRejected = "שינויי הלקוח נדחו בהצלחה";
